// Sticky right-hand action column.
//
// Grids run to twenty columns and scroll horizontally, and the row menu lives in
// the last cell — so on a wide grid the only way to act on a row was to scroll
// right first, losing sight of the row you were acting on.
//
// A sticky cell has to be opaque, otherwise the columns passing beneath show
// through. That means it cannot inherit the row's hover or selected background,
// so those are re-applied here by compositing the translucent state colour over
// the opaque one, which reproduces the row's colour exactly rather than
// approximating it.

const stateOverlay = (color) => ({
    backgroundImage: `linear-gradient(${color}, ${color})`
});

/** Body cell holding the row menu. */
export const stickyActionCellSx = (theme) => ({
    'position': 'sticky',
    'right': 0,
    // Above ordinary body cells, below the sticky header row.
    'zIndex': 1,
    'backgroundColor': theme.palette.background.paper,
    'borderLeft': `1px solid ${theme.palette.divider}`,
    '.MuiTableRow-root:hover &': stateOverlay(theme.palette.action.hover),
    '.MuiTableRow-root.Mui-selected &': stateOverlay(
        theme.palette.action.selected
    )
});

/**
 * Matching cell in the head, and in the sticky total row. Both need to clear the
 * sticky body cells, and both already sit on the neutral surface.
 */
export const stickyActionHeadCellSx = (theme) => ({
    position: 'sticky',
    right: 0,
    zIndex: 3,
    backgroundColor: theme.palette.background.neutral,
    borderLeft: `1px solid ${theme.palette.divider}`
});
